import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DatePicker from 'react-bootstrap-date-picker';
import NumberFormat from 'react-number-format';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ, PERMISSION_CREATE } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Action from '../Helper/Grid/Action';
import AdvancedCombobox from '../Helper/AdvancedCombobox';
import Combobox from '../Helper/Combobox';
import Grid from '../Helper/Grid';
import RemoteCheckboxComment from '../Helper/RemoteCheckboxComment';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Alerte from './Alerte';
import Client from './Client';
import Caution from './Caution';
import Document from './Document';
import Echange from './Echange';
import ElementContrat from './ElementContrat';
import Evenement from './Evenement';
import EtatDesLieux from './EtatDesLieux';
import FacturationEncaissement from './FacturationEncaissement';
import InfoParcelle from './InfoParcelle';
import Projet from './Projet';
import TaxeFonciere from './TaxeFonciere';

/**
* Class Contrat
* Contrat view component
**/
class Contrat extends AbstractEntity {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
		super(props);
    this.state.hideFacturationEncaissement = true;
  }

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Contrat";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateDebut = null, dateFin = null;

    if(this.state.object.dateDebut) {

      dateDebut = this.state.object.dateDebut;

      if(typeof dateDebut === "string") {
        dateDebut = getDateFromString(dateDebut);
      }

      dateDebut = getIsoStringFromDate(dateDebut);
    }

    if(this.state.object.dateFin) {

      dateFin = this.state.object.dateFin;

      if(typeof dateFin === "string") {
        dateFin = getDateFromString(dateFin);
      }

      dateFin = getIsoStringFromDate(dateFin);
    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    const fakeGrid = {
      props: {path: "projets"},
      getRowKey: function() {
        return "idProjet";
      }
    };

    let estFrequencePredefinie = this.state.estFrequencePredefinie;
    if(estFrequencePredefinie === undefined) {
      estFrequencePredefinie = !(this.getObjectProperty("frequenceFacturationValeur") !== "" || this.getObjectProperty("idUniteTempsFacturation") !== "");
    }

    return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
        <Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'occupation.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="numero">
            <Col componentClass={ControlLabel} sm={2}>N°</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("numero")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Type de l'occupation</ControlLabel></Col>
            <Col sm={2}><Combobox id="idTypeContrat" url={REST_API_URL + "typecontrats/"} optionValueKey="idTypeContrat" optionLabelKey="libelle"
              default={this.getObjectProperty("idTypeContrat")} onChange={this.handleTypeContratSelect.bind(this)} placeholder="Type de l'occupation" disabled={this.getReadOnly()} /></Col>

            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Etat de l'occupation</ControlLabel></Col>
            <Col sm={2}><Combobox id="idEtatContrat" url={REST_API_URL + "etatcontrats/"} optionValueKey="etatId" optionLabelKey="etatLibelle"
              default={this.getObjectProperty("idEtatContrat")} onChange={this.handleEtatContratSelect.bind(this)} placeholder="Etat de l'occupation" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="objet">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Objet</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("objet")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Site</ControlLabel></Col>
            <Col sm={2}><Combobox id="idSite" url={REST_API_URL + "sites/"} optionValueKey="siteId" optionLabelKey="siteNomCourt" searchable={true}
              default={this.getObjectProperty("idSite")} onChange={this.handleSiteSelect.bind(this)} placeholder="Site" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Client OneToMany */}
          <PermissionCheck component={Client.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="idClient">
              <Col componentClass={ControlLabel} sm={2}>Client</Col>
              <Col sm={6}><AdvancedCombobox path="clients" objectPath={this.getObjectPath() + "/clients"} objectClass={Client} url={REST_API_URL + "clients/"}
              optionValueKey="idClient" optionLabelKey="libelle" default={this.getObjectProperty("idClient")} onChange={this.handleClientSelect.bind(this)}
              disabled={this.getReadOnly()} enableSearch={true} withEdit={true} /></Col>
            </FormGroup>
          </PermissionCheck>

          {this.getObjectProperty("estBloque") === false &&
            <FormGroup controlId="idProjet">
              <Col componentClass={ControlLabel} sm={2}>Clause environnemental</Col>
              <Col sm={2}><Combobox ref="idProjet" url={REST_API_URL + "projets/?estEnvironnemental=true"} optionValueKey="idProjet" optionLabelKey="libelle"
                default={this.getObjectProperty("idProjet")} onChange={this.handleProjetSelect.bind(this)} placeholder="Clause" searchable={true} disabled={this.getReadOnly()} /></Col>
              <Col sm={2}>
                <Action object={{idProjet: this.getObjectProperty("idProjet")}} objectClass={Projet} parentGrid={fakeGrid}
                  fields={[{key: "idProjet"}]} mode={this.props.mode} withoutDelete={true}/>
              </Col>
            </FormGroup>
          }

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Date de début</Col>
            <Col sm={2}>
              <FormGroup validationState={this.getRequiredFieldValidationState("dateDebut")}>
                <DatePicker id="dateDebut" dateFormat="DD/MM/YYYY" value={dateDebut} onChange={this.handleDateDebutChange} disabled={this.getReadOnly()} />
              </FormGroup>
            </Col>

            <Col componentClass={ControlLabel} sm={1}>Date de fin</Col>
            <Col sm={2}>
              <FormGroup validationState={this.getRequiredFieldValidationState("dateFin")}>
                <DatePicker id="dateFin" minDate={dateDebut} dateFormat="DD/MM/YYYY" value={dateFin} onChange={this.handleDateFinChange} disabled={this.getReadOnly()} />
              </FormGroup>
            </Col>

            <Col componentClass={ControlLabel} sm={1}><ControlLabel>Durée</ControlLabel></Col>
            <Col sm={1}><FormControl id="duree" type="number" min={0} onChange={this.handleDureeChange.bind(this)} value={this.getObjectProperty("duree")} disabled={this.getReadOnly()} /></Col>
            <Col sm={2}><Combobox id="idUniteTempsDuree" ref="cbxUniteTempsDuree" url={REST_API_URL + "unitetemps/"} optionValueKey="idUniteTemps" optionLabelKey="libelle"
              default={this.getObjectProperty("idUniteTempsDuree")} onChange={this.handleUniteTempsDureeSelect.bind(this)} placeholder="Unite de temps" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* {this.state.mode !== "add" && this.getObjectProperty("dateFin") &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_CREATE}>
              <FormGroup>
                <Col smOffset={2} sm={2}>
                  <Button bsStyle="primary" onClick={this.createFinContratAlerte.bind(this)}>Générer les alertes de fin de contrat</Button>
                </Col>
              </FormGroup>
            </PermissionCheck>
          } */}

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Réglementation</ControlLabel></Col>
            <Col sm={2}><Combobox id="idReglementation" url={REST_API_URL + "reglementations/"} optionValueKey="idReglementation" optionLabelKey="libelle"
              default={this.getObjectProperty("idReglementation")} onChange={this.handleReglementationSelect.bind(this)} placeholder="Réglementation" disabled={this.getReadOnly()} /></Col>

            <Col sm={2}><Checkbox name="taciteReconduction" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("taciteReconduction")} disabled={this.getReadOnly()}>Tacite reconduction</Checkbox></Col>

            <Col sm={2}><Checkbox name="droitReel" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("droitReel")} disabled={this.getReadOnly()}>Droits réels</Checkbox></Col>

            <Col sm={2}><Checkbox name="transaction" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("transaction")} disabled={this.getReadOnly()}>Est transactionnel</Checkbox></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Numéro de SIREN</Col>
            <Col sm={2}><FormControl id="numeroSiren" type="text" onChange={this.handleChange} value={this.getObjectProperty("numeroSiren")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col smOffset={2} sm={2}><Checkbox name="activitePortuaire" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("activitePortuaire")} disabled={this.getReadOnly()}>Activité portuaire</Checkbox></Col>

            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Secteur d'activité</ControlLabel></Col>
            <Col sm={3}>
              <Combobox url={REST_API_URL + "secteuractivites/"} optionValueKey="idSecteurActivite" optionLabelKey="libelle"
              default={this.getObjectProperty("idSecteurActivite")} onChange={this.handleSecteurActiviteSelect.bind(this)} placeholder="Secteur d'activité" disabled={this.getReadOnly()} />
            </Col>

            <Col componentClass={ControlLabel} sm={1}>Code NAF/APE</Col>
            <Col sm={1}><FormControl id="codeNaf" type="text" onChange={this.handleChange} value={this.getObjectProperty("codeNaf")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nombre d'emplois</ControlLabel></Col>
            <Col sm={2}><FormControl id="nombreEmploi" type="number" onChange={this.handleChange} value={this.getObjectProperty("nombreEmploi")} disabled={this.getReadOnly()} /></Col>

            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Montant investi</ControlLabel></Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("montantInvesti")} onValueChange={this.handleMontantInvestiChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          {(this.getObjectProperty("tribunal") === true || this.getObjectProperty("tribunal") === false) &&
            <FormGroup>
              <Col smOffset={2} sm={1}><Checkbox name="tribunal" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("tribunal")} disabled={this.getReadOnly()}>Tribunal</Checkbox></Col>
            </FormGroup>
          }

          {this.getObjectProperty("tribunal") === true &&
            <FormGroup controlId="motifTribunal">
              <Col smOffset={2} componentClass={ControlLabel} sm={6}>
                <FormControl onChange={this.handleChange} componentClass="textarea" rows="5" placeholder="Motif"
                  value={this.getObjectProperty("motifTribunal")} disabled={this.getReadOnly()} />
              </Col>
            </FormGroup>
          }

          <FormGroup>
            <Col smOffset={2} sm={2}><Checkbox name="occupationBati" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("occupationBati")} disabled={this.getReadOnly()}>Occupation bâtiment</Checkbox></Col>

            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Dimension bâtiment</ControlLabel></Col>
            <Col sm={2}>
              <FormControl id="dimensionBati" type="number" step={0.01} onChange={this.handleChange} value={this.getObjectProperty("dimensionBati")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <RemoteCheckboxComment ref="contratCharges" parent={this} readonly={this.getReadOnly()}
            idField="charge.idCharge" labelField="charge.libelle" valueField="presenceCharge" commentField="commentaire"
            path={this.state.mode === "add" ? "contratcharges/charges" : "contrats/" + this.getObjectProperty("idContrat") + "/contratcharges"} />

          <FormGroup controlId="idParcelleGestionPag">
            <Col componentClass={ControlLabel} sm={2}>Parcelle</Col>
            <Col sm={2}>
              <Combobox ref="cbxParcelle" url={REST_API_URL + "parcellegestionpag/"} optionValueKey="gid" optionLabelKey="idu"
                default={this.getObjectProperty("idParcelleGestionPag")} onChange={this.handleParcelleSelect.bind(this)} placeholder="Parcelle" searchable={true}
                disabled={this.getReadOnly()} />
            </Col>
            {this.getObjectProperty("idParcelleGestionPag") &&
              <Col sm={2}>
                <Button bsStyle="primary" onClick={this.showParcelleModal.bind(this)}>Informations parcelle</Button>
                <InfoParcelle ref="infoParcelleModal" object={this.getObjectProperty("infoParcelle")} contrat={this} />
              </Col>
            }
          </FormGroup>

          <FormGroup controlId="observationAdminJuridique">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Observations administratives et juridiques</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("observationAdminJuridique")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="observationFinanciere">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Observations financières</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("observationFinanciere")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="observationOperationnel">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Observations opérationnelles</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("observationOperationnel")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Prélèvement</ControlLabel></Col>
            <Col sm={4}><Combobox ref="cbxFrequenceFacturation" url={REST_API_URL + "frequencefacturations/"} optionValueKey="idFrequenceFacturation" optionLabelKey="libelle"
              default={this.getObjectProperty("idFrequenceFacturation")} onChange={this.handleFrequenceFacturationSelect.bind(this)} placeholder="Fréquence de facturation"
              disabled={this.getReadOnly() || estFrequencePredefinie === false} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Redevance théorique annuelle</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("redevanceTheoriqueAnnuelle")}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={true} />
            </Col>

            {/* <Col componentClass={ControlLabel} sm={2}>Redevance théorique au {getStringFromDate(new Date())}</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("redevanceTheoriqueActuelle")}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={true} />
            </Col> */}

            <Col componentClass={ControlLabel} sm={2}>Facturation actuelle</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("facturationActuelle")}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={true} />
            </Col>
          </FormGroup>

          {/* Caution OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Caution.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Cautions" path="cautions" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/cautions"}
              objectClass={Caution} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* ElementContrat OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={ElementContrat.getClassName()} permission={PERMISSION_READ}>
              <Grid ref="elementContratGrid" title="Eléments d'occupation" path="elementcontrats" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/elementcontrats"}
              objectClass={ElementContrat} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* FacturationEncaissement OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={FacturationEncaissement.getClassName()} permission={PERMISSION_READ}>
              <div>
                {this.getFacturationEncaissementRecapTab()}
                {this.state.hideFacturationEncaissement === false &&
                  <Grid title="" onReload={this.onFacturationEncaissementReload.bind(this)} ref="facturationEncaissementGrid" path="facturationencaissements"
                    objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/facturationencaissements"}
                  objectClass={FacturationEncaissement} hidden={false} mode={this.state.mode} />
                }
              </div>
            </PermissionCheck>
          }

          {/* TaxeFonciere OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={TaxeFonciere.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Taxes foncières" path="taxefoncieres" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/taxefoncieres"}
              hiddable={true} objectClass={TaxeFonciere} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* EtatDesLieux OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={EtatDesLieux.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Etats des lieux" path="etatdeslieux" objectPath={"contrats/" + this.getObjectProperty("idContrat") + "/etatdeslieux"} objectClass={EtatDesLieux}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {/* {(this.state.mode !== "add") &&
            <GeometryGrid title="Géométries" path="contrats_geoms" objectPath={"contrats_geoms/" + this.getObjectProperty("idContrat")} objectClass={Contrat} mode={this.state.mode}
              queryLayers="pt_mouillage,zone_mouillage,parcelle_gestion_pag" allowDraw={true} selectionMultiple={true} typeGeometry="all" withImportCsv={true} withImportPoint={true} />
          } */}

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/documents"} objectClass={Document}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Evenement OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Evenement.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Evènements" path="evenements" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/evenements"} objectClass={Evenement}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Alerte OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" ref="gridAlerte" path="alertes" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/alertes"} objectClass={Alerte}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Echange OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Echange.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Echanges" path="echanges" objectPath={"contrats/" + this.getObjectProperty(this.getIdField()) + "/echanges"} objectClass={Echange}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" &&
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup>
          }
        </Form>
      </div>
    );
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let contratObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.clientsGrid !== undefined) contratObj.clients = this.refs.clientsGrid.getArrayToSave();
    }

    if(typeof contratObj.dateDebut !== "string") {
      contratObj.dateDebut = getStringFromDate(contratObj.dateDebut);
    }

    if(typeof contratObj.dateFin !== "string") {
      contratObj.dateFin = getStringFromDate(contratObj.dateFin);
    }

    contratObj.activitePortuaire = contratObj.activitePortuaire === true;
    contratObj.taciteReconduction = contratObj.taciteReconduction === true;
    contratObj.occupationBati = contratObj.occupationBati === true;
    contratObj.droitReel = contratObj.droitReel === true;
    contratObj.transaction = contratObj.transaction === true;

    contratObj.contratCharges = this.refs.contratCharges.getData();

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(contratObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();

        this.setState({
          status: {
            type: 'success',
            message: 'Occupation sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });

        this.createDateFinContratAlerte(this.state.object);
        this.refs.gridAlerte.reload();
        if(this.refs.elementContratGrid !== undefined) this.refs.elementContratGrid.reload();
      this.replaceHistory(APP_PATH + "/contrats/" + this.getObjectProperty("idContrat") + "/edit", this.state);
        window.location.reload();
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Occupation créée.'
          },
          mode: 'edit',
          object: newObj

        };

        this.state.object=newObj;
console.log(newObj);
        this.createDateFinContratAlerte(newObj);

        //if(this.state.mode === "edit") {

        //}
        this.replaceHistory(APP_PATH + "/contrats/" + newObj.idContrat + "/edit", state);


      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.proprietairesGrid !== undefined) this.refs.proprietairesGrid.saveAll();
    if(this.refs.clientsGrid !== undefined) this.refs.clientsGrid.saveAll();
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idContrat";
  }

  /**
  * handleTypeContratSelect
  * Handle type contrat onChange event
  **/
  handleTypeContratSelect(typeContrat) {
    let objState = this.state;
    objState.object["idTypeContrat"] = (typeContrat) ? typeContrat.idTypeContrat : null;
    this.setState(objState);
  }

  /**
  * handleSiteSelect
  * Handle site onChange event
  **/
  handleSiteSelect(site) {
    let objState = this.state;
    objState.object["idSite"] = (site) ? site.siteId : null;
    this.setState(objState);
  }

  /**
  * handleEtatContratSelect
  * Handle état contrat onChange event
  **/
  handleEtatContratSelect(etatContrat) {
    let objState = this.state;
    objState.object["idEtatContrat"] = (etatContrat) ? etatContrat.etatId : null;
    objState.object["tribunal"] = (etatContrat.tribunal === true && objState.tribunal !== true && objState.tribunal !== false) ? false : null;
    this.setState(objState);
  }

  /**
  * handleSectionSelect
  * Handle section onChange event
  **/
  handleSectionSelect(section, cbx) {
      const str = (section) ? section.idu : "";
      const cbxParcelle = this.refs.cbxParcelle;
      cbxParcelle.setSearchString(str);
  }

  /**
  * handleParcelleSelect
  * Handle parcelle onChange event
  **/
  handleParcelleSelect(parcelle, cbx) {
    let objState = this.state;
    objState.object["idParcelleGestionPag"] = (parcelle) ? parcelle.gid : null;
    this.setState(objState);
  }

  /**
  * handleSecteurActiviteSelect
  * Handle secteur activite onChange event
  **/
  handleSecteurActiviteSelect(secteurActivite) {
    let objState = this.state;
    objState.object["idSecteurActivite"] = (secteurActivite) ? secteurActivite.idSecteurActivite : null;
    this.setState(objState);
  }

  /**
  * handleReglementationSelect
  * Handle reglementation onChange event
  **/
  handleReglementationSelect(reglementation) {
    let objState = this.state;
    objState.object["idReglementation"] = (reglementation) ? reglementation.idReglementation : null;
    this.setState(objState);
  }

  /**
  * handleProjetSelect
  * Handle projet onChange event
  **/
  handleProjetSelect(projet) {
    let objState = this.state;
    objState.object["idProjet"] = (projet) ? projet.idProjet : null;
    this.setState(objState);
  }

  /**
  * handleClientSelect
  * Handle client onChange event
  **/
  handleClientSelect(client) {
    let objState = this.state;
    objState.object["idClient"] = (client) ? client.idClient : null;
    this.setState(objState);
  }

  /**
  * handleDureeChange
  * Modify the state from Duree field change
  **/
  handleDureeChange(e) {
    let objState = this.state;
    const duree = e.target.value;
    const idUniteTempsDuree = this.getObjectProperty("idUniteTempsDuree");
    objState.object[e.target.id] = duree;

    if(idUniteTempsDuree && duree) {
      objState = this.getDateFin(duree, idUniteTempsDuree, objState);
    }

    this.setState(objState);
  }

  /**
  * handleUniteTempsDureeSelect
  * Handle UniteTemps onChange event
  **/
  handleUniteTempsDureeSelect(uniteTemps) {
    let objState = this.state;
    const idUniteTempsDuree = (uniteTemps) ? uniteTemps.idUniteTemps : null;
    const duree = this.getObjectProperty("duree");
    objState.object["idUniteTempsDuree"] = idUniteTempsDuree;

    if(idUniteTempsDuree && duree) {
      objState = this.getDateFin(duree, idUniteTempsDuree, objState);
    }

    this.setState(objState);
  }

  /**
  * getDateFin
  * Modify the state of dateFin
  **/
  getDateFin(duree, idUniteTempsDuree, objState) {
    const dateDebutValue = this.getObjectProperty("dateDebut");
    duree = parseInt(duree, 10);

    if(dateDebutValue && duree) {
      const dateDebut = (dateDebutValue instanceof Date) ? dateDebutValue : getDateFromString(dateDebutValue);
      let dateFin = new Date(dateDebut);

      switch (idUniteTempsDuree) {
        case 1:
          dateFin.setDate(dateDebut.getDate() + duree);
          break;
        case 2:
          dateFin.setDate(dateDebut.getDate() + duree * 7);
          dateFin.setDate(dateFin.getDate() - 1);
          break;
        case 3:
          dateFin.setMonth(dateDebut.getMonth() + duree);
          dateFin.setDate(dateFin.getDate() - 1);
          break;
        case 4:
          dateFin.setFullYear(dateDebut.getFullYear() + duree);
          dateFin.setDate(dateFin.getDate() - 1);
          break;
        default:
          break;
      }

      objState.object.dateFin = dateFin;
    }

    return objState;
  }

  /**
  * handleDateDebutChange
  * Modify the state dateDebut property from dateDebut field change
  **/
  handleDateDebutChange(dateString, formattedDate) {
    let objState = this.state;
    const dateDebut = (dateString !== null) ? getDateFromString(formattedDate) : null;
    objState.object["dateDebut"] = dateDebut;

    if(this.state.object.dateFin) {
      const dateFin = (this.state.object.dateFin instanceof Date) ? this.state.object.dateFin : getDateFromString(this.state.object.dateFin);
      objState = this.getUniteTempsDureeState(dateDebut, dateFin, objState);
    }

    this.setState(objState);
  }

  /**
  * handleDateFinChange
  * Modify the state dateFin property from dateFin field change
  **/
  handleDateFinChange(dateString, formattedDate) {
    let objState = this.state;
    const dateFin = (dateString !== null) ? getDateFromString(formattedDate) : null;
    objState.object["dateFin"] = dateFin;

    if(dateFin && this.state.object.dateDebut) {
      const dateDebut = (this.state.object.dateDebut instanceof Date) ? this.state.object.dateDebut : getDateFromString(this.state.object.dateDebut);
      objState = this.getUniteTempsDureeState(dateDebut, dateFin, objState);
    }

    this.setState(objState);
  }

  /**
  * getUniteTempsDureeState
  * Modify the state of duree and UniteTemps
  **/
  getUniteTempsDureeState(dateDebut, dateFin, objState) {
    let duree = null, idUniteTempsDuree = null;
    const dateCompare = new Date(dateFin);
    dateCompare.setDate(dateCompare.getDate() + 1);

    // Cas année tombe juste
    if(dateCompare.getFullYear() > dateDebut.getFullYear() && dateCompare.getMonth() === dateDebut.getMonth() && dateCompare.getDate() === dateDebut.getDate()) {
      duree = dateCompare.getFullYear() - dateDebut.getFullYear();
      idUniteTempsDuree = 4;
    }
    // Cas mois tombe juste
    else if(((dateCompare.getFullYear() === dateDebut.getFullYear() && dateCompare.getMonth() > dateDebut.getMonth())
            ||dateCompare.getFullYear() >= dateDebut.getFullYear())
           && dateCompare.getDate() === dateDebut.getDate()) {
      const yearMonthDiff = (dateCompare.getFullYear() - dateDebut.getFullYear()) * 12;
      duree = yearMonthDiff + (dateCompare.getMonth() - dateDebut.getMonth());
      idUniteTempsDuree = 3;
    } else {
      const ecart = (dateCompare - dateDebut);
      const dayDiff = Math.round(ecart / (1000 * 60 * 60 * 24));

      // Cas semaine tombe juste
      if(dayDiff !== 0 && dayDiff%7 === 0) {
        duree = dayDiff / 7;
        idUniteTempsDuree = 2;
      }
      // Cas jours
      else {
        duree = dayDiff;
        idUniteTempsDuree = 1;
      }
    }

    objState.object.duree = duree;
    objState.object.idUniteTempsDuree = idUniteTempsDuree;

    this.refs.cbxUniteTempsDuree.setValue(idUniteTempsDuree);

    return objState;
  }

  /**
  * handleFrequenceFacturationSelect
  * Handle frequence facturation onChange event
  **/
  handleFrequenceFacturationSelect(frequenceFacturation) {
    let objState = this.state;
    objState.object["idFrequenceFacturation"] = (frequenceFacturation) ? frequenceFacturation.idFrequenceFacturation : null;
    this.setState(objState);
  }

  /**
  * handleUniteTempsFacturationSelect
  * Handle unité temps onChange event
  **/
  handleUniteTempsFacturationSelect(uniteTempsFacturation) {
    let objState = this.state;
    objState.object["idUniteTempsFacturation"] = (uniteTempsFacturation) ? uniteTempsFacturation.idUniteTemps : null;
    this.setState(objState);
  }

  /**
  * handleRadFrequenceChange
  * Handle frequence radio onChange event
  **/
  handleRadFrequenceChange(event) {
    let objState = this.state;
    const estFrequencePredefinie = event.target.value === "true";

    objState.estFrequencePredefinie = estFrequencePredefinie;

    if(estFrequencePredefinie === true) {
      objState.object.frequenceFacturationValeur = null;
      objState.object.idUniteTempsFacturation = null;
    } else {
      objState.object.idFrequenceFacturation = null;
    }

    this.setState(objState);

    let cbxFrequenceFacturationState = this.refs.cbxFrequenceFacturation.state;
    cbxFrequenceFacturationState.cbxProps.disabled = !estFrequencePredefinie;

    this.refs.cbxFrequenceFacturation.clear();
    this.refs.cbxFrequenceFacturation.setState(cbxFrequenceFacturationState);

    let cbxUniteTempsState = this.refs.cbxUniteTempsFacturation.state;
    cbxUniteTempsState.cbxProps.disabled = estFrequencePredefinie;

    this.refs.cbxUniteTempsFacturation.clear();
    this.refs.cbxUniteTempsFacturation.setState(cbxUniteTempsState);
  }

  /**
  * onFacturationEncaissementReload
  * Handle FacturationEncaissement grid refresh
  **/
  onFacturationEncaissementReload() {
    if(this.refs.facturationEncaissementGrid) {
      let state = this.state;
      let recap = [];

      this.refs.facturationEncaissementGrid.state.objects.forEach(function(object) {
        const date = object.date;
        const annee = date instanceof Date ? date.getFullYear() : "Non défini";

        if(recap[annee] === undefined) recap[annee] = { annee: annee, facture: 0, encaisse: 0 };

        switch(object.idTypeFacturationEncaissement) {
          case 2:
            recap[annee].encaisse = parseFloat((recap[annee].encaisse + object.montant).toFixed(2));
            break;
          case 1:
            recap[annee].facture = parseFloat((recap[annee].facture + object.montant).toFixed(2));
            break;
          default:
            break;
        }

      });

      let recetteActuelle = 0.0;
      let facturationActuelle = 0.0;

      const currentYear = (new Date()).getFullYear();
      recap.forEach(function(obj) {
        if(obj.annee === currentYear && obj.encaisse) recetteActuelle = obj.encaisse;
        if(obj.annee === currentYear && obj.facture) facturationActuelle = obj.facture;
      });

      state.object.recetteActuelle = recetteActuelle;
      state.object.recetteActuelle = facturationActuelle;

      recap.sort((obj1, obj2) => obj1.annee < obj2.annee);
      state.facturationEncaissementRecap = recap;
      this.setState(state);
    }
  }

  /**
  * getFacturationEncaissementRecapTab
  * Returns recap table
  **/
  getFacturationEncaissementRecapTab() {
    return(
      <div className="listContainer" id="facturationEncaissementRecapGrid">
        <h4 className="gridTitle" onClick={this.showFacturationEncaissementGrid.bind(this)}>
          Facturations
          <span className={"glyphicon glyphicon-chevron-" + (this.state.hideFacturationEncaissement === false ? "down" : "right")}></span>
        </h4>

        {this.state.hideFacturationEncaissement === false && this.state.facturationEncaissementRecap ?
          <div>
            <div className={"grid tarificationRecapGrid"}>
              <BootstrapTable ref={"tableRecapTarification"} data={this.state.facturationEncaissementRecap} options={{noDataText: 'Aucune donnée à afficher'}} striped>
                <TableHeaderColumn key="annee" dataField="annee" isKey={true} ref="facturationEncaissementRecapGridAnnee" dataSort={false}>Année</TableHeaderColumn>
                <TableHeaderColumn key="facture" dataField="facture" dataFormat={this.currencyFormatter} isKey={false}
                  ref="facturationEncaissementRecapGridFacture" dataSort={false}>Facturé</TableHeaderColumn>
                {/* <TableHeaderColumn key="encaisse" dataField="encaisse" dataFormat={this.currencyFormatter} isKey={false}
                  ref="facturationEncaissementRecapGridEncaisse" dataSort={false}>Encaissé</TableHeaderColumn> */}
              </BootstrapTable>
            </div>
          </div> : null
        }
      </div>
    );
  }

  /**
  * currencyFormatter
  * Formats currency numbers
  **/
  currencyFormatter(cell, row, extraParams) {
    return cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "€";
  }

  /**
  * showFacturationEncaissementGrid
  * Manage FacturationEncaissement grid visilibity
  **/
  showFacturationEncaissementGrid() {
    let state = this.state;
    state.hideFacturationEncaissement = !state.hideFacturationEncaissement;
    this.setState(state);
  }

  /**
  * showParcelleModal
  * Manage InfoParcelle Modal visilibity
  **/
  showParcelleModal() {
    if(this.refs.infoParcelleModal) {
      this.refs.infoParcelleModal.show();
    }
  }

  /**
  * handleMontantInvestiChange
  * Handle montant change
  **/
  handleMontantInvestiChange(values) {
    let objState = this.state;
    objState.object["montantInvesti"] = values.value;
    this.setState(objState);
  }



  /**
  * createFinContratAlerte
  * Create Alerte de fin de contrat
  **/
  createFinContratAlerte() {

    if (confirm('Une sauvegarde va être effectuée, voulez vous continuer?'))
    {


      this.sendFormData();

      const path = REST_API_URL + this.getObjectPath() + "/alertes_fin";
      let contratObj = this.state.object;

      if(typeof contratObj.dateDebut !== "string") {
        contratObj.dateDebut = getStringFromDate(contratObj.dateDebut);
      }

      if(typeof contratObj.dateFin !== "string") {
        contratObj.dateFin = getStringFromDate(contratObj.dateFin);
      }

      rest({
        method: "PUT",
        path: path,
        entity: JSON.stringify(contratObj),
        headers: {
    			'Content-Type': 'application/json'
    		}
      }).then(response => {
        if(response.status.code === 201) {
          const newObj = JSON.parse(response.entity);

          const state = {
            status: {
              type: 'success',
              message: 'Alerte de fin de contrat créée.'
            },
            mode: 'edit',
            object: newObj
          };

          this.setState(state);
          this.pushHistory(APP_PATH + "/alertes/" + newObj.idAlerte + "/edit", state);

        } else {
          this.setState({
            status: {
              type: 'danger',
              message: 'Erreur de sauvegarde.'
            }
          });
        }
    	}, response => {
        this.setState({
          status: {
            type: 'danger',
            message: 'Problème d\'appel au serveur.'
          }
        });
  		});

    }
  }

  /**
  * createDateFinContratAlerte
  * Create Alerte de fin de contrat
  **/
  createDateFinContratAlerte(object) {


      const path = REST_API_URL + "/contrats/" + object.idContratStr + "/alertes_fin";
      let contratObj = object;

      if(typeof contratObj.dateDebut !== "string") {
        contratObj.dateDebut = getStringFromDate(contratObj.dateDebut);
      }

      if(typeof contratObj.dateFin !== "string") {
        contratObj.dateFin = getStringFromDate(contratObj.dateFin);
      }

      rest({
        method: "PUT",
        path: path,
        entity: JSON.stringify(contratObj),
        headers: {
    			'Content-Type': 'application/json'
    		}
      }).then(response => {
        if(response.status.code === 201) {
          // const newObj = JSON.parse(response.entity);
          //
          // const state = {
          //   status: {
          //     type: 'success',
          //     message: 'Alerte de fin de contrat créée.'
          //   },
          //   mode: 'edit',
          //   object: newObj
          // };
          //
          // this.setState(state);
          // this.pushHistory(APP_PATH + "/alertes/" + newObj.idAlerte + "/edit", state);

        } else {
          this.setState({
            status: {
              type: 'danger',
              message: 'Erreur de sauvegarde.'
            }
          });
        }
    	}, response => {
        this.setState({
          status: {
            type: 'danger',
            message: 'Problème d\'appel au serveur.'
          }
        });
  		});
  }
}

export default Contrat;



// WEBPACK FOOTER //
// ./src/views/Entity/Contrat.js